import { render, staticRenderFns } from "./ZoneCreate.vue?vue&type=template&id=3a48c050&"
import script from "./ZoneCreate.vue?vue&type=script&lang=ts&"
export * from "./ZoneCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports